<template>
  <RevButtonBase
    class="flex w-full items-start gap-12 text-left"
    @click="$emit('click')"
  >
    <RevIllustration
      v-if="image"
      alt=""
      class="h-24 w-24"
      :height="24"
      :src="image"
      :width="24"
    />
    <span class="body-1-bold flex-1">
      {{ title }}
    </span>
    <IconChevronRight />
  </RevButtonBase>
</template>

<script setup lang="ts">
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevIllustration } from '@ds/components/Illustration'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

defineProps<{
  title: string
  image?: string
}>()

defineEmits<{
  click: []
}>()
</script>
